module.exports = __webpack_public_path__ + "img/step11_a_basket_basic_fix_rear_cross_with_two_screws.89307f50.png";